import "./styles/ui.css";
import App from "./App.js";

// Point d'entrée de l'application
const app = new App();
app.mount("#app");
